import { render, staticRenderFns } from "./Bounty.vue?vue&type=template&id=45d25d86&scoped=true"
import script from "./Bounty.vue?vue&type=script&lang=js"
export * from "./Bounty.vue?vue&type=script&lang=js"
import style0 from "./Bounty.vue?vue&type=style&index=0&id=45d25d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d25d86",
  null
  
)

export default component.exports